/*
 *   File : faq.js
 *   Author : https://evoqins.com
 *   Description : FAQ page
 *   Integrations : 
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { TextButton } from "../../Component/Buttons";
import { Icon } from "../../Component/Icon";
import { _scrollToTop } from "../../Helper";

// Styles 
import Colors from "../../Styles/color.scss";

// Custom Data

const FAQ_DATA = [
    {
        id: 1,
        question: "What is Indvestment?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 2,
        question: "How do I create an account?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 3,
        question: "What is an investment basket and how does it work?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 4,
        question: "Are there any fees for using Indvestment?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 5,
        question: "Can I transfer my existing investments to Indvestment?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 6,
        question: "Can I cancel my order anytime I want? Will I still get my money back?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 7,
        question: "What kind of customer support does Indvestment offer?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 8,
        question: "What types of investments can I make on Indvestment?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
];

function Faq(props) {

    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();
    }, []);

    // handle search 
    const _handleSearch = (value) => {
        setSearchValue(value);
    };

    const _handleBack = () => {
        navigate(-1);
        // props.handlePublicRouter();
    };

    return (
        <div>
            <TextButton name="FAQ"
                labelClass="e-font-16-res"
                icon={true}
                type={2}
                onPress={_handleBack} />

            <div className="row">

                <div className={props.type == 2 ? "col-12" : "col-12 col-lg-10 col-xl-7"}>
                    <div className="pt-3 pb-0 card-box-shadow e-bg-white my-4 border-radius-8 px-0">
                        {/* <div className='row mb-4 justify-content-end px-3'>
                            <div className='col-12 col-sm-7'>
                                <div className='d-flex align-items-center gap-2 justify-content-end'>
                                    <CustomSearchInput placeholder="Search with product names"
                                        type="text"
                                        require
                                        wrapperClassName="col-8 col-sm-12"
                                        search={true}
                                        value={searchValue}
                                        handleChange={_handleSearch} />

                                    <div className='e-padding-8px-tb-12px-lr-res d-flex gap-6px align-items-center e-border-0-5-ocean-blue e-bg-magnolia px-2 px-sm-3 padding-10px-tb border-radius-100 cursor-pointer'>
                                        <div className='d-flex position-relative'>
                                            <img src={require("../../Assets/Images/Other/filter.svg").default}
                                                width={18} />
                                            <span class="position-absolute top-0 left-84-per translate-middle badge rounded-pill e-bg-filter-count e-text-white e-alt-font-lato e-font-8 e-font-weight-700 line-height-10px px-1 padding-1px-top padding-2px-bottom">
                                                2
                                            </span>
                                        </div>
                                        <p className='e-font-12-res mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                            Filter
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="row px-3">
                            <div class="accordion accordion-flush d-flex flex-column gap-4" id="faq-accordion">
                                {
                                    FAQ_DATA.map((item, index) => (
                                        <div div class="accordion-item pb-3 e-border-1px-anti-flash-white">
                                            <h2 class="accordion-header">
                                                <button class={`${index == 0 ? "" : "collapsed"} p-0 accordion-button bg-transparent shadow-none e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px e-letter-spacing-min-point-1px`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#faq-accordion-${index + 1}`}
                                                    aria-expanded="false"
                                                    aria-controls="flush-collapseOne">
                                                    {item.question}
                                                </button>
                                            </h2>
                                            <div id={`faq-accordion-${index + 1}`}
                                                className={`${index === 0 && "show"} accordion-collapse collapse`}
                                                data-bs-parent="#faq-accordion">
                                                <div class="accordion-body px-0 pb-0 padding-12px-top e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className="row m-0 p-0">
                            {/* Support team info */}
                            <div className="py-3 e-bg-magnolia " id="gradient-border-support-info">

                                <h6 className="mb-0 e-text-chinese-black e-primary-font-clash-display e-font-weight-500 e-font-16 line-height-24px">
                                    Don't hesitate to get in touch!
                                </h6>
                                <p className="mb-0 e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-12 line-height-18px">
                                    Our support team is here to help!
                                </p>
                                <div className='d-flex flex-wrap align-items-center gap-3 gap-sm-5 margin-20px-top'>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <span className="d-flex align-items-center justify-content-center e-secondary-bg-gradient w-18px h-18 border-radius-80 line-height-0px">
                                            <Icon icon={"e-mail"}
                                                color={Colors.magnolia}
                                                size="10px" />
                                        </span>
                                        <a href='mailto:hello@Indvestment.in' className='text-decoration-none text-decoration-hover-underline text-reset'>
                                            <span className="e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px">
                                                hello@indvestment.com
                                            </span>
                                        </a>
                                    </div>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <span className="d-flex align-items-center justify-content-center e-secondary-bg-gradient w-18px h-18 border-radius-80 line-height-0px">
                                            <Icon icon={"phone-icon"}
                                                color={Colors.magnolia}
                                                size="10px" />
                                        </span>
                                        <a href='tel:+919876543210' className='text-decoration-none text-decoration-hover-underline text-reset'>
                                            <span className="e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px">
                                                +91 98765 43210
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                {/* {
                    props.type !== 2 &&
                    <div className="col-5">
                        <ProfileCard navigate={true} />
                    </div>
                } */}
            </div>
        </div>
    )
}

export default Faq